import { Script, ScriptType, Statement } from "../../api/models";

export enum OnlineStatementsScriptName {
  OnlineStatementsProcessing = "onlineStatmentsProcessing",
}

export const onlineStatementsScriptOS003 = (
  statements: Statement[],
): Script[] =>
  statements
    .filter(({ isProcessing }) => isProcessing)
    .map(({ title }) => ({
      scriptType: ScriptType.Dialogue,
      dialogue: `The statement for ${title} is being processed.`,
    }));
